
import { computed, defineComponent, PropType } from 'vue';
import LinkButton from '@/shared/navigation/LinkButton.vue';
import { CampaignViewModel, HeroBannerTileModel } from '@/types/B2BcontentServerContract';

export default defineComponent({
    name: 'HeroBannerContent',
    components: { LinkButton },
    props: {
        content: {
            required: true,
            type: Object as PropType<HeroBannerTileModel | CampaignViewModel>,
            default: () => {},
        },
        italicBottomTitle: {
            type: Boolean,
            required: false,
            default: false,
        },
        showLinkButton: {
            type: Boolean,
            required: false,
            default: false,
        },
        title: {
            required: false,
            type: String,
            default: '',
        },
    },
    setup(props) {
        const shouldShowLinkButton = computed(() => {
            const hasLinkUrl = props.content.link?.url.length > 0 ?? false;
            return props.showLinkButton && hasLinkUrl;
        });

        return {
            shouldShowLinkButton,
        };
    },
});
